export function isTel(selectorString) {
    return /^tel:/.test(selectorString);
}